export enum AllowedFormCharacters {
  NUMBERS = 'numbers',
  LETTERS = 'letters'
}
